import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore, { selectIsLoggedIn } from '../../store/authStore';

/**
 * 로그인이 필요한 구역. 부팅(토큰 검증) 중에는 스켈레톤을 보여주고,
 * 게스트면 로그인으로 보내되 돌아올 경로를 남긴다.
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const isLoggedIn = useAuthStore(selectIsLoggedIn);
  const status = useAuthStore(s => s.status);

  if (status === 'idle' || status === 'booting') {
    return (
      <div className="wrap" style={{ padding: '60px 0' }}>
        <div className="skel" style={{ height: 28, width: 220, marginBottom: 18 }} />
        <div className="skel" style={{ height: 16, width: 360, marginBottom: 32 }} />
        <div className="skel" style={{ height: 220 }} />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
